export enum SourceSystem {
  Arcadia = 'arcadia.io',
}
